/*global google*/

const IA_SCRIPT = "https://www.gstatic.com/instantapps/js/1/library.js";

export const detectInstantApp = (loadScript) => {
  if (window.sessionStorage && !window.sessionStorage.getItem('iaFlag')) {
    loadScript(IA_SCRIPT).then(
      // If script loads successfully, still need to try catch the response from the provided function.
      () => {
        try {
          google.aia.classifyVisitor(function(res) {
             idInstantApp((!!res.eligible).toString());
           });
        } catch(e) {
          idInstantApp('scriptFailed');
        }
      },
      // If script fails to load, trigger fail tracking response.
      () => {idInstantApp('scriptFailed')}
    )
  }
};

const idInstantApp = (instantAppEligibilityFlag) => {
  if (window.RdcTracking) {
    window.RdcTracking.trackEvent('instantAppEligibilityFlagEvent', {instantAppEligibilityFlag});
  }
  if (instantAppEligibilityFlag !== 'scriptFailed' && window.sessionStorage) {
    window.sessionStorage.setItem('iaFlag', true);
  }
};

export default detectInstantApp;



// WEBPACK FOOTER //
// ./shared_critical/instant_app_detection.js